export class CashType {
  static types = [
      {value: 0, name: 'Pay'},
      {value: 1, name: 'Receive'},
    ];
}

export class CashTransactionType {
  static types = [
      {value: 0, name: 'Management Fees'},
      {value: 1, name: 'Performance Fees'},
      {value: 2, name: 'Interest'},
      {value: 3, name: 'Dividends'},
      {value: 4, name: 'Subscription/Redemption'},
      {value: 5, name: 'Other income/expense'}
    ];
}


